// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5750":"2fd24744","7453":"51b428b6","9116":"2fd24744"}[chunkId] + ".chunk.css";
};